var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15706_12796",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15706_12796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6908 11.25C17.3697 11.25 17.1014 11.1422 16.8858 10.9267C16.6703 10.7111 16.5625 10.4403 16.5625 10.1142V5.51075C16.5625 5.18469 16.6711 4.91389 16.8883 4.69835C17.1056 4.48278 17.3748 4.375 17.6959 4.375H24.4966C24.8177 4.375 25.0861 4.48278 25.3016 4.69835C25.5172 4.91389 25.6249 5.18469 25.6249 5.51075V10.1142C25.6249 10.4403 25.5163 10.7111 25.2991 10.9267C25.0818 11.1422 24.8126 11.25 24.4915 11.25H17.6908ZM5.50334 15.6249C5.18222 15.6249 4.91389 15.5171 4.69834 15.3015C4.48278 15.0858 4.375 14.8187 4.375 14.4999V5.49978C4.375 5.18103 4.48362 4.91389 4.70087 4.69835C4.91812 4.48278 5.18732 4.375 5.50847 4.375H12.3091C12.6302 4.375 12.8986 4.48282 13.1141 4.69847C13.3297 4.91409 13.4374 5.18128 13.4374 5.50003V14.5002C13.4374 14.8189 13.3288 15.0861 13.1116 15.3016C12.8943 15.5172 12.6251 15.6249 12.304 15.6249H5.50334ZM17.6908 25.6249C17.3697 25.6249 17.1014 25.5171 16.8858 25.3015C16.6703 25.0858 16.5625 24.8187 16.5625 24.4999V15.4998C16.5625 15.181 16.6711 14.9139 16.8883 14.6983C17.1056 14.4828 17.3748 14.375 17.6959 14.375H24.4966C24.8177 14.375 25.0861 14.4828 25.3016 14.6985C25.5172 14.9141 25.6249 15.1813 25.6249 15.5V24.5002C25.6249 24.8189 25.5163 25.0861 25.2991 25.3016C25.0818 25.5172 24.8126 25.6249 24.4915 25.6249H17.6908ZM5.50334 25.6249C5.18222 25.6249 4.91389 25.5172 4.69834 25.3016C4.48278 25.0861 4.375 24.8153 4.375 24.4892V19.8857C4.375 19.5596 4.48362 19.2888 4.70087 19.0733C4.91812 18.8577 5.18732 18.75 5.50847 18.75H12.3091C12.6302 18.75 12.8986 18.8577 13.1141 19.0733C13.3297 19.2888 13.4374 19.5596 13.4374 19.8857V24.4892C13.4374 24.8153 13.3288 25.0861 13.1116 25.3016C12.8943 25.5172 12.6251 25.6249 12.304 25.6249H5.50334Z",
    fill: "#FD9567"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.8f9a50ec4a5181cff1f00d02f862b43d.svg";
export { ForwardRef as ReactComponent };